import MobileSheet from './MobileSheet';
import UserAvatar from '../UserAvatar';
import { CameraIcon, LoaderIcon } from './Icons';
import useUserProfile from '../../hooks/useUserProfile';

export default function UserProfileMobile({ userProfile, onClose, onProfileUpdated, showToast }) {
  const { uploading, preview, fileRef, handleFileSelect, handleUpload, handleCancel } =
    useUserProfile({ userProfile, onProfileUpdated, onClose, showToast });

  return (
    <MobileSheet
      title="My Profile"
      onClose={onClose}
      showFooter={!!preview}
      footer={
        preview ? (
          <div className="mobile-sheet-footer-actions">
            <button className="mobile-btn mobile-btn-secondary mobile-btn-sm" onClick={handleCancel} disabled={uploading}>
              Cancel
            </button>
            <button className="mobile-btn mobile-btn-primary mobile-btn-sm" onClick={handleUpload} disabled={uploading}>
              {uploading ? <><LoaderIcon size={14} /> Saving...</> : 'Save Photo'}
            </button>
          </div>
        ) : null
      }
    >
      <div className="mobile-profile-content">
        <div className="mobile-profile-avatar-section">
          {preview ? (
            <div className="mobile-profile-avatar-large">
              <img src={preview} alt="Preview" className="mobile-profile-avatar-preview" />
            </div>
          ) : (
            <UserAvatar user={userProfile} size={80} showStatus={false} />
          )}
          <button
            className="mobile-profile-change-btn"
            onClick={() => fileRef.current?.click()}
            disabled={uploading}
          >
            <CameraIcon size={14} /> Change Photo
          </button>
          <input
            ref={fileRef}
            type="file"
            accept="image/*"
            onChange={handleFileSelect}
            style={{ display: 'none' }}
          />
        </div>
        <div className="mobile-profile-info">
          <div className="mobile-profile-row">
            <span className="mobile-profile-label">Name</span>
            <span className="mobile-profile-value">{userProfile.displayName}</span>
          </div>
          <div className="mobile-profile-row">
            <span className="mobile-profile-label">Email</span>
            <span className="mobile-profile-value">{userProfile.email}</span>
          </div>
          <div className="mobile-profile-row">
            <span className="mobile-profile-label">Role</span>
            <span className="mobile-profile-value" style={{ textTransform: 'capitalize' }}>{userProfile.role}</span>
          </div>
        </div>
      </div>
    </MobileSheet>
  );
}
